import { Navigate, Route, Routes } from 'react-router-dom';

// layout
import CommonLayout from 'components/layout/CommonLayout';
import LoginLayout from 'components/layout/LoginLayout';

// pages
import Creator from './creator/Creator';
import CreatorReport from './creator/CreatorReport';
import Dashboard from './dashboard/Dashboard';
import Login from './login/Login';
import PasswordHelp from './login/PasswordHelp';
import TrackingDetail from './tracking/TrackingDetail';
import TrackingList from './tracking/TrackingList';

const PageRouter = () => {
	return (
		<>
			<Routes>
				<Route element={<CommonLayout />}>
					<Route path="dashboard" element={<Dashboard />} />
					<Route path="creator" element={<Creator />} />
					<Route
						path="creator/:platformCode/:creatorPk/:groupId"
						element={<CreatorReport />}
					/>
					<Route path="tracking" element={<TrackingList />} />
					<Route path="tracking/:code" element={<TrackingDetail />} />
					<Route path="*" element={<Navigate to="/dashboard" replace />} />
				</Route>
				<Route path="login" element={<LoginLayout />}>
					<Route path="password_help" element={<PasswordHelp />} />
					<Route index element={<Login />} />
				</Route>
			</Routes>
		</>
	);
};

export default PageRouter;
